import {
    GET_AccessL,
    ADD_AccessL,
    TOGGLE_AccessL,
    RESET_AccessL,
    UPDATE_AccessL
  } from "../actionTypes";

const accessLevelReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_AccessL:
      return action.payload;

    case ADD_AccessL:
      return action.payload;

    case UPDATE_AccessL:
      return state.map(item =>
        item.id === action.payload.id ? action.payload : item
      );

    case TOGGLE_AccessL:
      return {
        ...state,
        users: state.users.map(item =>
          item.userId === action.payload.userId ? action.payload : item
        )
      };

    case RESET_AccessL:
      return null;

    default:
      return state;
  }
};

export default accessLevelReducer;
